export function viewportWidth() {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

export function viewportHeight() {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}
